import Home from "../index/Home.vue";
import Login from "../auth/Login.vue";

const createRouter = () => new VueRouter({
    // mode: 'history', // require service support
    scrollBehavior: () => ({y: 0}),
    routes: [
        {
            path: '/',
            component: Home,
            meta: {title: 'Home'},
            name: 'index'
        },
        {
            path: '/login',
            component: Login,
            meta: {title: 'Login'},
            name: 'login'
        },
        {
            path: '*',
            component: () => require('../error/404'),
            name: '404'
        }
    ]
});

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export function addRoutes(routes, capability) {
    routes.map(route => {
        if (capability === 'administrator' || (Array.isArray(route.meta.capabilities) && route.meta.capabilities.includes(capability))) {
            //console.log(route);
            router.addRoute(route);
        }
    });
}

const router = createRouter()
export default router